// TestoGrande.tsx — v037: l'interruttore «Testo grande» (Home → lingua, e profilo).
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { scegliTestoGrande, testoGrandeAttivo } from "../servizi/testoGrande.ts";
import { vibra } from "../servizi/nativo.ts";

export function InterruttoreTestoGrande() {
  const { t } = useTranslation();
  const [si, setSi] = useState(testoGrandeAttivo);
  return (
    <label className="interruttore ld-testo-grande-scelta">
      <input
        type="checkbox"
        checked={si}
        onChange={(e) => {
          vibra("scelta");
          setSi(e.target.checked);
          scegliTestoGrande(e.target.checked);
        }}
      />
      <span>{t("aspetto.testo_grande")}</span>
    </label>
  );
}
